import React from 'react'
import { TouchableOpacity, Dimensions, Linking } from 'react-native'
import { isAndroid } from '../../utils/platformUtils'
import themes from '../../../theme'
import StyledText from '../../../StyledText'
import { useNavigation } from '../../hooks/useWebNavigation'
import { Platform } from 'react-native'
import { AntDesign } from '@expo/vector-icons'
import { getBenefitVoucherById } from '../../db/benefits'
import {
    getCategoriesWithSubcategoriesAndProducts,
    getCategoryById,
} from '../../db/portfolio'
import { openDB } from '../../db/indexDB'
import { CommentsModalByGoToNotifications } from './ItemDefault'
import { LearningServices } from '../../../database/learning.database'
import { fetchAuthSession } from 'aws-amplify/auth'
import { request_get_training_courses_home } from '../../services/courses.services'
import styles from './Go_toStyles'
import { colorText } from '../../../themeConstants'
import { schedulesServices } from '../../../database/schedules.database'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { GOTO_PATH } from './constants/goto.constants'
import { debug, info, warn, error } from '../../utils/logger'
import { useBreakpoint } from '@/redux/zustand/useDimensionStore'

const Go_to = ({ go_to }) => {
    let navigation = null
    try {
        navigation = useNavigation()
    } catch (e) {
        if (Platform.OS === 'web') {
            navigation = { navigate: () => {}, goBack: () => {} }
            if (process?.env?.NODE_ENV !== 'production')
                warn('Go_to', 'useNavigation fallback (web)')
        } else {
            throw e
        }
    }
    const safeNav = {
        navigate: (name, params) => {
            try {
                return navigation.navigate(name, params)
            } catch (e) {
                warn('CTA', 'navigate proxy failed', e?.message)
            }
        },
        goBack: () => {
            try {
                if (typeof navigation.goBack === 'function')
                    return navigation.goBack()
            } catch {}
        },
        getCurrentRoute: () => {
            try {
                if (typeof navigation.getCurrentRoute === 'function')
                    return navigation.getCurrentRoute()
            } catch {}
            try {
                if (typeof navigation.getState === 'function') {
                    const st = navigation.getState()
                    const idx = typeof st.index === 'number' ? st.index : 0
                    return st.routes?.[idx] || st.routes?.[0] || null
                }
            } catch {}
            return null
        },
    }
    const bp = useBreakpoint()
    const isMobile = bp === 'sm'
    return (
        <TouchableOpacity
            style={[styles.go_to_container, !isMobile && { marginTop: 0 }]}
            onPress={() => onClickRedirect(go_to, safeNav)}
        >
            <StyledText
                style={{
                    flexShrink: 1,
                    color: colorText,
                    fontWeight: 'bold',
                    fontSize: 15,
                }}
            >
                {go_to.text}
            </StyledText>
            <AntDesign name='right' size={17} color={colorText} />
        </TouchableOpacity>
    )
}

// Web helper: fetch course from API when no local DB exists
const fetchCourseFromApiWeb = async (courseId = null, moduleID = null) => {
    info('CTA', 'fetchCourseFromApiWeb init', { courseId })
    try {
        const session = await fetchAuthSession()
        const authToken = session.tokens?.accessToken?.toString() || ''
        if (!authToken) {
            warn('CTA', 'No auth token available for course fetch')
        }
        const data = await request_get_training_courses_home({ authToken })
        const categories = data?.single?.categories || []
        debug('CTA', 'home categories len', categories.length)
        // Flatten repository courses
        let found = null
        let moduleFound = null
        for (const cat of categories) {
            const repo = Array.isArray(cat?.repository) ? cat.repository : []
            if (courseId) {
                found = repo.find((c) => c && c._id === courseId)
            }
            if (moduleID) {
                // found = repo.find((c) => c && Array.isArray(c.moduls) && c.moduls.find((m) => m._id === moduleID))
                for (const curso of repo) {
                    let modulos = curso.moduls || []
                    let nextMod = modulos.find((m) => m && m._id === moduleID)
                    if (nextMod) {
                        moduleFound = nextMod
                        found = curso
                        break
                    }
                }
            }
            if (found) break
        }
        if (!found) {
            warn('CTA', 'Course not found in home payload', courseId)
            return null
        }
        // Ensure shape expected by Course screen
        if (courseId) {
            const course = {
                ...found,
                moduls: Array.isArray(found.moduls) ? found.moduls : [],
                evaluations: Array.isArray(found.evaluations)
                    ? found.evaluations
                    : [],
            }
            return course
        }

        if (moduleID) {
            const module = {
                courseItem: found,
                item: moduleFound,
                labelNextCourse: 'Continuar curso',
            }
            return module
        }
        info('CTA', 'Course fetched from API', {
            id: course._id,
            moduls: course.moduls.length,
            evals: course.evaluations.length,
        })
    } catch (err) {
        error('CTA', 'fetchCourseFromApiWeb error', err?.message)
        return null
    }
}

const onClickRedirect = async (
    go_to,
    navigation,
    setBenefit,
    setPostID,
    db,
    openBottomSheet,
) => {
    console.log('GOTO DATA ==>', go_to)
    switch (go_to.type) {
        case 'externo':
            debug(
                'PDF',
                'externo CTA pressed → default WebView flow (may be overridden on web)',
            )
            let url = go_to.path
            const ext = url.toLowerCase().slice(url.lastIndexOf('.')) ?? ''
            const extList = [
                '.pdf',
                '.doc',
                '.docx',
                '.xls',
                '.xlsx',
                '.ppt',
                '.pptx',
            ]
            // Web: si es PDF, descargar y abrir en pestaña nueva
            if (Platform.OS === 'web') {
                try {
                    if (ext === '.pdf') {
                        info(
                            'PDF',
                            'Web externo PDF detected, starting download',
                            url,
                        )
                        try {
                            const res = await fetch(url)
                            const blob = await res.blob()
                            const blobUrl = URL.createObjectURL(blob)
                            // Descargar
                            const name = url.split('/').pop() || 'archivo.pdf'
                            const a = document.createElement('a')
                            a.href = blobUrl
                            a.download = name
                            document.body.appendChild(a)
                            a.click()
                            document.body.removeChild(a)
                            // Abrir nueva pestaña
                            window.open(blobUrl, '_blank', 'noopener')
                            setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000)
                            break
                        } catch (err) {
                            warn(
                                'PDF',
                                'Fetch failed, opening direct PDF in new tab',
                                err?.message,
                            )
                            try {
                                window.open(url, '_blank', 'noopener')
                            } catch {}
                            break
                        }
                    } else {
                        // No es PDF: abrir en nueva pestaña directamente (mejor UX que WebView)
                        debug('PDF', 'Web externo non-PDF, opening in new tab', url)
                        try {
                            window.open(url, '_blank', 'noopener')
                        } catch {
                            Linking.openURL(url)
                        }
                        break
                    }
                } catch (e) {
                    warn(
                        'PDF',
                        'Web externo handler error, fallback to WebView',
                        e?.message,
                    )
                }
            }
            // Nativo: para office docs usar visor Google, si no abrir con Linking o WebView
            if (isAndroid()) {
                if (extList.includes(ext)) {
                    url = `https://drive.google.com/viewerng/viewer?embedded=true&url=${url}`
                } else {
                    Linking.openURL(url)
                    break
                }
            }
            debug('PDF', 'Fallback navigate to WebView with link', url)
            navigation.navigate('WebView', { link: url })
            break
        case 'interno':
            debug('CTA', 'interno go_to payload', go_to)

            switch (go_to.path) {
                //Faltan los de cursos y ver como mandar a la home de c/seccion
                // Tambien faltaria exportar esto a otro archivo para reutilizar con notificaciones
                case 'wall':
                    setPostID(go_to.id_content)
                    // En web, evitar goBack y navegar directamente
                    console.log('[Go_to] Navigating to PostsList')
                    // Navegar directamente a PostsList sin hacer goBack para evitar remounts.
                    try {
                        navigation.navigate('PostsList')
                    } catch (e) {
                        // Fallback: intentar replace si navigate falla
                        try {
                            navigation.replace && navigation.replace('PostsList')
                        } catch (err) {}
                    }
                    break

                case 'comment':
                    setPostID(go_to.post_id)
                    navigation.navigate('PostsList')

                    const snapPoints = ['45%']

                    setTimeout(() => {
                        openBottomSheet(
                            <CommentsModalByGoToNotifications
                                post_id={go_to.post_id}
                                comment_id={go_to.id_content}
                            />,
                            snapPoints,
                        )
                    }, 200)

                    break
                case 'profile':
                    navigation.navigate('Profile')
                    break
                case 'editprofile':
                    navigation.navigate('EditProfile')
                    break
                case 'portfolio':
                    if (go_to.item != null) {
                        let data = go_to.item
                        if (data.categories != null && data.categories.length > 0) {
                            switch (data.categories.length) {
                                case 0:
                                    // console.log('Entro 1')
                                    navigation.navigate('Portfolio')
                                    break
                                default:
                                    // console.log('Entro 2')
                                    const database = await openDB()
                                    await getCategoriesWithSubcategoriesAndProducts(
                                        database,
                                    ).then((categories) => {
                                        let catToGo = categories.filter(
                                            (cat) => cat._id === go_to.id_content,
                                        )
                                        if (catToGo.length > 0) {
                                            navigation.navigate('SubCategory', {
                                                categories: catToGo,
                                            }) // lo mando a la home y recibo id
                                        } else {
                                            navigation.navigate('Portfolio')
                                        }
                                    })
                                    break
                            }
                            break
                        } else {
                            if (data.products && data.products.length > 0) {
                                navigation.navigate('PortfolioProducts', {
                                    categoryId: data._id,
                                    products: data.products,
                                    item: data,
                                })
                            }
                        }
                    }

                    break
                case 'categories':
                    const database = await openDB()
                    await getCategoriesWithSubcategoriesAndProducts(database).then(
                        (categories) => {
                            let catToGo = categories.filter(
                                (cat) => cat._id === go_to.id_content,
                            )
                            if (catToGo.length > 0) {
                                navigation.navigate('SubCategory', {
                                    categories: catToGo,
                                }) // lo mando a la home y recibo id
                            } else {
                                navigation.navigate('Portfolio')
                            }
                        },
                    )
                    break

                    break
                case 'category_products':
                    navigation.navigate('PortfolioProducts', {
                        categoryId: go_to.id_content,
                    })
                    break
                case 'catalogue':
                    navigation.navigate('Portfolio', {
                        categoryId: go_to.id_content,
                    })
                    break
                case 'learninghome':
                case 'learning_home':
                    info('CTA', 'navigate LearningHome')
                    navigation.navigate('LearningHome')
                    break
                case 'course':
                    try {
                        info('CTA', 'CTA course pressed', go_to)
                        let course = null
                        if (Platform.OS === 'web') {
                            course = await fetchCourseFromApiWeb(go_to.id_content)
                        } else {
                            //  course = await LearningServices.get_course_by_id(go_to.id_content)
                            course = { _id: go_to.id_content }
                        }
                        if (!course) {
                            warn('CTA', 'course not found, aborting navigation.')
                            return
                        }
                        const params_course = { item: course, array_cursos: [] }
                        info('CTA', 'navigate Course with params', {
                            id: course._id,
                        })
                        navigation.navigate('Course', params_course)
                    } catch (err) {
                        error('CTA', 'error fetching/navigating course', err)
                    }
                    break
                case 'content':
                    let moduleID = go_to.id_content
                    let data = await fetchCourseFromApiWeb(null, moduleID)
                    if (!data)
                        return console.error(
                            'Module not found, cant navigate =====>',
                        )
                    const params = {
                        item: data.item,
                        courseItem: data.courseItem,
                        labelNextCourse: data.labelNextCourse,
                    }
                    navigation.navigate('Module', params)

                    break
                case 'benefits':
                    if (go_to.item) {
                        setBenefit(go_to.item)
                        navigation.navigate('BenefitsHome')
                    } else {
                        getBenefitVoucherById(db, go_to.id_content)
                            .then((benefit) => {
                                if (benefit) {
                                    setBenefit(benefit)
                                    navigation.navigate('BenefitsHome')
                                } else {
                                    warn('CTA', 'Beneficio no encontrado')
                                }
                            })
                            .catch((error) => {
                                error('CTA', 'Error al obtener el beneficio', error)
                            })
                    }
                    break
                case 'store':
                    try {
                        const currentRoute = navigation.getCurrentRoute()
                        if (currentRoute?.name != 'Schedule') {
                            //primero va a la agenda, despues a la tienda y de la tienda al form
                            await AsyncStorage.setItem(
                                'hasNavigatedToStore',
                                'false',
                            )
                            console.log('STORE ID ==> ', go_to.store_id)
                            navigation.navigate('Schedule', {
                                store_id: JSON.stringify(go_to),
                            })
                        } else {
                            //si estas en la agenda te lleva directamente a la tienda
                            setTimeout(async () => {
                                await schedulesServices
                                    .getStoreForGoto(go_to.store_id)
                                    .then(async (store) => {
                                        if (store) {
                                            let params_store = {
                                                storeID: go_to.store_id,
                                                forms: JSON.parse(store.forms),
                                                scheduleID: store.schedule_id,
                                                steps: null,
                                                forms_relevant: [],
                                                forms_advances: JSON.parse(
                                                    store.forms_advances,
                                                ),
                                                distance: 0,
                                                store_status: store.campaign_status,
                                                navigate_form: go_to.id_form
                                                    ? go_to.id_form
                                                    : null,
                                            }
                                            navigation.navigate(
                                                'StoreDetail',
                                                params_store,
                                            )
                                        } else {
                                            warn(
                                                'CTA',
                                                '================NO ESTA LA TIENDA====================',
                                            )
                                        }
                                    })
                                    .catch((error) => {
                                        error('CTA', 'Store fetch error', error)
                                    })
                            }, 1000)
                        }
                    } catch (error) {
                        error('CTA', 'onClickRedirect error', error)
                    }
                    break

                case GOTO_PATH.PERIOD:
                    debug('CTA', 'PERIOD goto', go_to)

                    switch (go_to.screen) {
                        case 'ModeratorRelevateWeeks':
                            debug('CTA', 'ModeratorRelevateWeeks')
                            if (go_to.period_id && go_to.id_content) {
                                let params = {
                                    id_period: go_to.period_id,
                                    id_week: go_to.id_content,
                                }
                                navigation.navigate('ModeratorRelevateWeeks', params)
                            }
                            break

                        case 'CreateScheduleHome':
                            debug('CTA', 'CreateScheduleHome')
                            navigation.navigate('CreateScheduleHome')
                            break

                        case 'CreateSchedule':
                            debug('CTA', 'CreateSchedule')
                            if (go_to.id_content && go_to.period_id) {
                                let params = {
                                    week_id: go_to.id_content,
                                    period_id: go_to.period_id,
                                }
                                navigation.navigate('CreateSchedule', params)
                            }
                            break
                        default:
                            break
                    }

                    break
                default:
                    warn('CTA', 'No se encontro el path')
            }
            break
        default:
            warn('CTA', 'Hubo un error al cargar la media')
            break
    }
}

export { Go_to, onClickRedirect }
